/**
 * Resolves list data from API payloads that may be:
 * - a bare array, or
 * - `{ entries: T[] }`, or
 * - `{ rows: T[] }`.
 *
 * **Never** read `.entries` on a value that might be an array: on arrays, `entries` is
 * `Array.prototype.entries` (a function), not row data — the same bug as rotation mapping (school schedule).
 */
export function coalesceEntriesOrRows<T = unknown>(value: unknown): T[] | undefined {
  if (value === null || value === undefined) return undefined
  if (Array.isArray(value)) return value as T[]
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>
    const list = o.entries ?? o.rows
    return Array.isArray(list) ? (list as T[]) : undefined
  }
  return undefined
}
